import { useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import ReactPaginate from 'react-paginate';

import Tile from './Tile'
import SearchInput from './SearchInput';

export interface IPropertyMapProps {
	data?: any
	savedProperies: string[]
	dataAutocomplete?: any
	query?: any
	setQuery: (any: any) => void
	openFilter?: () => void
	resetQuery?: () => void
	openMobileMap?: () => void
	toggleToSaved: (id: string) => void
	hasFilters?: boolean
	numberOfFilters: number
}

const PropertyMap = ({ numberOfFilters, toggleToSaved, data, dataAutocomplete, setQuery, query, savedProperies, openFilter, openMobileMap, hasFilters, resetQuery }: IPropertyMapProps) => {

	const itemsPerPage = 12;
	const currentPage = query?.page || 1;
	const endOffset = (currentPage) * itemsPerPage;

	const currentItems = data?.properties.sort((a,b) => {
		if (query.sort == 'newest') {
			return new Date(b.createDate).getTime() - new Date(a.createDate).getTime();
		} else if (query.sort == 'oldest') {
			return new Date(a.createDate).getTime() - new Date(b.createDate).getTime();
		} else if (query.sort == 'high') {
			return parseInt(b.price) - parseInt(a.price);
		} else if (query.sort == 'low') {
			return parseInt(a.price) - parseInt(b.price);
		} else if (query.sort == 'suburb') {
			return a.suburb.localeCompare(b.suburb);
		} else {
			return new Date(b.createDate).getTime() - new Date(a.createDate).getTime();
		}
	}).slice(((currentPage - 1) * itemsPerPage), endOffset);

	const pageCount = Math.ceil(data?.properties.length / itemsPerPage);

	const handlePageClick = (selected: number) => {
		const newOffset = selected + 1;

		console.log(newOffset)

		setQuery({page: newOffset});
		document?.getElementById("search-container").scrollIntoView({block: "start", behavior: "smooth"});
	};

	return (
		<>
			<div className='search-container' id='search-container'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-8'>
							<SearchInput
								icon={
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" clipRule="evenodd" d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.551 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9056 16.3199C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z" fill="#86C0C7"/>
									</svg>
								}
								onChange={(e) => {
									setQuery({search: e.target.value, agent: '', page: 1})}
								}
								clearResults={() => {
									setQuery({search: '', agent: '', page: 1})
								}}
								value={query?.agent || query?.search}
								autocomplete={dataAutocomplete}
								setQuery={setQuery}
							/>
						</div>
						<div className='col-md-4 filter-area'>
							<button onClick={openMobileMap} className='btn brand accent map-btn'>
								<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M5.65737 3.45332C6.42479 2.94055 7.32703 2.66686 8.25 2.66686C9.17297 2.66686 10.0752 2.94055 10.8426 3.45332C11.6101 3.96609 12.2082 4.69491 12.5614 5.54762C12.9146 6.40032 13.0071 7.33862 12.827 8.24386C12.647 9.14909 12.2025 9.98062 11.5499 10.6333L8.7215 13.4617C8.5965 13.5866 8.42703 13.6567 8.25034 13.6567C8.07364 13.6567 7.90417 13.5866 7.77917 13.4617L4.95002 10.6332C4.29743 9.98056 3.85303 9.14907 3.67299 8.24386C3.49294 7.33862 3.58537 6.40032 3.93859 5.54762C4.2918 4.69491 4.88994 3.96609 5.65737 3.45332ZM8.25 1.33353C7.06333 1.33353 5.9033 1.68541 4.91661 2.34469C3.92993 3.00396 3.16089 3.94102 2.70676 5.03735C2.25262 6.13369 2.13378 7.34008 2.36527 8.50395C2.59675 9.66783 3.16824 10.737 4.00732 11.5761L6.83684 14.405C7.21185 14.7796 7.72025 14.99 8.25034 14.99C8.78042 14.99 9.28906 14.7794 9.66407 14.4047L12.4928 11.5761C13.3318 10.7369 13.9032 9.66783 14.1347 8.50395C14.3662 7.34008 14.2474 6.13369 13.7932 5.03735C13.3391 3.94102 12.5701 3.00396 11.5834 2.34469C10.5967 1.68541 9.43668 1.33353 8.25 1.33353ZM8.25 4.66667C7.54276 4.66667 6.86448 4.94762 6.36438 5.44771C5.86428 5.94781 5.58333 6.62609 5.58333 7.33333C5.58333 8.04058 5.86428 8.71885 6.36438 9.21895C6.86448 9.71905 7.54276 10 8.25 10C8.95724 10 9.63552 9.71905 10.1356 9.21895C10.6357 8.71885 10.9167 8.04058 10.9167 7.33333C10.9167 6.62609 10.6357 5.94781 10.1356 5.44771C9.63552 4.94762 8.95724 4.66667 8.25 4.66667ZM7.30719 6.39052C7.55724 6.14048 7.89638 6 8.25 6C8.60362 6 8.94276 6.14048 9.19281 6.39052C9.44286 6.64057 9.58333 6.97971 9.58333 7.33333C9.58333 7.68696 9.44286 8.02609 9.19281 8.27614C8.94276 8.52619 8.60362 8.66667 8.25 8.66667C7.89638 8.66667 7.55724 8.52619 7.30719 8.27614C7.05714 8.02609 6.91667 7.68696 6.91667 7.33333C6.91667 6.97971 7.05714 6.64057 7.30719 6.39052Z" fill="white"/>
								</svg>
								<span>Map</span>
							</button>
							<button onClick={openFilter} className='btn filter-btn button-secondary'>
								{numberOfFilters > 0 ?
									<span className='filter-number'>{numberOfFilters || 0}</span>
								:
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" clipRule="evenodd" d="M7.91912 2.58579C8.29419 2.21071 8.8029 2 9.33333 2C9.86377 2 10.3725 2.21071 10.7475 2.58579C10.9605 2.79872 11.1204 3.05473 11.219 3.33333H13.3333C13.7015 3.33333 14 3.63181 14 4C14 4.36819 13.7015 4.66667 13.3333 4.66667H11.219C11.1204 4.94527 10.9605 5.20128 10.7475 5.41421C10.3725 5.78929 9.86377 6 9.33333 6C8.8029 6 8.29419 5.78929 7.91912 5.41421C7.70618 5.20128 7.54622 4.94527 7.44771 4.66667H2.66667C2.29848 4.66667 2 4.36819 2 4C2 3.63181 2.29848 3.33333 2.66667 3.33333H7.44771C7.54622 3.05473 7.70618 2.79872 7.91912 2.58579ZM8.86193 4.4714C8.73694 4.34641 8.66671 4.1769 8.66667 4.00015V4C8.66667 3.82319 8.7369 3.65362 8.86193 3.5286C8.98695 3.40357 9.15652 3.33333 9.33333 3.33333C9.51014 3.33333 9.67971 3.40357 9.80474 3.5286C9.92976 3.65362 10 3.82319 10 4C10 4.17681 9.92976 4.34638 9.80474 4.4714C9.67971 4.59643 9.51014 4.66667 9.33333 4.66667C9.15652 4.66667 8.98695 4.59643 8.86193 4.4714ZM3.91912 6.58579C4.29419 6.21071 4.8029 6 5.33333 6C5.86377 6 6.37247 6.21071 6.74755 6.58579C6.96048 6.79872 7.12045 7.05473 7.21895 7.33333H13.3333C13.7015 7.33333 14 7.63181 14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667H7.21895C7.12045 8.94527 6.96048 9.20128 6.74755 9.41421C6.37247 9.78929 5.86377 10 5.33333 10C4.8029 10 4.29419 9.78929 3.91912 9.41421C3.70618 9.20128 3.54622 8.94527 3.44771 8.66667H2.66667C2.29848 8.66667 2 8.36819 2 8C2 7.63181 2.29848 7.33333 2.66667 7.33333H3.44771C3.54622 7.05473 3.70618 6.79872 3.91912 6.58579ZM5.80474 7.5286C5.92976 7.65362 6 7.82319 6 8C6 8.17681 5.92976 8.34638 5.80474 8.4714C5.67971 8.59643 5.51014 8.66667 5.33333 8.66667C5.15652 8.66667 4.98695 8.59643 4.86193 8.4714C4.7369 8.34638 4.66667 8.17681 4.66667 8C4.66667 7.82319 4.7369 7.65362 4.86193 7.5286C4.98695 7.40357 5.15652 7.33333 5.33333 7.33333C5.51014 7.33333 5.67971 7.40357 5.80474 7.5286ZM11.3333 10C10.8029 10 10.2942 10.2107 9.91912 10.5858C9.70618 10.7987 9.54622 11.0547 9.44771 11.3333H2.66667C2.29848 11.3333 2 11.6318 2 12C2 12.3682 2.29848 12.6667 2.66667 12.6667H9.44771C9.54622 12.9453 9.70618 13.2013 9.91912 13.4142C10.2942 13.7893 10.8029 14 11.3333 14C11.8638 14 12.3725 13.7893 12.7475 13.4142C12.9605 13.2013 13.1204 12.9453 13.219 12.6667H13.3333C13.7015 12.6667 14 12.3682 14 12C14 11.6318 13.7015 11.3333 13.3333 11.3333H13.219C13.1204 11.0547 12.9605 10.7987 12.7475 10.5858C12.3725 10.2107 11.8638 10 11.3333 10ZM12 12C12 11.8232 11.9298 11.6536 11.8047 11.5286C11.6797 11.4036 11.5101 11.3333 11.3333 11.3333C11.1565 11.3333 10.987 11.4036 10.8619 11.5286C10.737 11.6535 10.6668 11.8228 10.6667 11.9994L10.6667 12C10.6667 12.1768 10.7369 12.3464 10.8619 12.4714C10.987 12.5964 11.1565 12.6667 11.3333 12.6667C11.5101 12.6667 11.6797 12.5964 11.8047 12.4714C11.9298 12.3464 12 12.1768 12 12Z" fill="#214359"/>
									</svg>
								}
								<span>Filters</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div className='listing-container'>
				<div className='container'>
					<div className='results-bar'>
						<div className='results-container'>
							{data?.properties ?
								<p className="results-text">{data?.properties.length > 0 ? ((currentPage-1) * itemsPerPage) + 1 : 0}-{endOffset < data?.properties.length ? endOffset : data?.properties.length} of {data?.properties.length} Listings</p>
							:
								<Skeleton width={128} height={16} />
							}
							{hasFilters &&
								<button onClick={() => {
									resetQuery();
								}} className='btn-clear-filter'>
									Reset filters
								</button>
							}
						</div>
						<select className='form-control custom-select' name="date-filter" value={query?.sort || 'newest'} id="date-filter" onChange={(e) => {
							setQuery({sort: e.target.value})
						}}>
							<option value="high">Price (High to Low)</option>
							<option value="low">Price (Low to High)</option>
							<option value="newest">Date (Newest to Oldest)</option>
							<option value="oldest">Date (Oldest to Newest)</option>
							<option value="suburb">Suburb</option>
						</select>
					</div>
					<div className="listing-grid">
						{!!data ? currentItems?.map((item: any, index: number) => (
							<Tile data={item} saved={savedProperies?.find(val => val == item?.id)} toggleToSaved={toggleToSaved} isLoggedIn={data.isLoggedIn} key={item?.id} />
						))
						:
						[...Array(12)]?.map((item: any, index: number) => (
							<Skeleton width={"100%"} height={350} key={index} />
						))}
						{data ? data?.properties?.length === 0 && <p className='no-results'>No results found</p> : null}
					</div>
					{data?.properties ?
						pageCount > 1 &&
							<>
								<div className="media-desktop-pagination">
								<ReactPaginate
									breakLabel="..."
									previousLabel="PREV"
									nextLabel="NEXT"
									onPageChange={(e) => {handlePageClick(e.selected)}}
									pageRangeDisplayed={3}
									marginPagesDisplayed={1}
									forcePage={((currentPage) - 1)}
									pageCount={pageCount || 0}

									// Styling
									containerClassName={"pagination-container"}
									pageClassName={"pagination-page"}
									activeClassName={"pagination-active"}
									previousLinkClassName={"button-secondary"}
									nextLinkClassName={"button-secondary"}
									disabledLinkClassName={"button-disabled"}
								/>
								</div>
								<div className="media-mobile-pagination">
									<button onClick={() => {
									handlePageClick((currentPage - 1) - 1);
									}} className="btn brand accent" style={{padding: 12}} disabled={currentPage <= 1}>
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fillRule="evenodd" clipRule="evenodd" d="M11.0588 15.3332L4 7.99984L11.0588 0.666504L12 1.64428L5.88235 7.99984L12 14.3554L11.0588 15.3332Z" fill="white"/>
										</svg>
									</button>
									<p style={{margin: 0}}>{currentPage || 1} of {pageCount || 1}</p>
									<button onClick={() => {
										handlePageClick((currentPage - 1) + 1);
									}} className="btn brand accent" style={{padding: 12}} disabled={currentPage >= (pageCount || 0)}>
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fillRule="evenodd" clipRule="evenodd" d="M4.94118 15.3332L12 7.99984L4.94118 0.666504L4 1.64428L10.1176 7.99984L4 14.3554L4.94118 15.3332Z" fill="white"/>
										</svg>
									</button>
								</div>
							</>
					:
						<Skeleton height={40} width="100%" />
					}
				</div>
			</div>
		</>
	)
}

export default PropertyMap
